import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage, setMessageStatus } from "./messages";

import AuthService from "../services/auth.service";


export const getMembers = createAsyncThunk(
    "get-members",
    async (pageNumber, thunkAPI) => {
        try {
            const data = await AuthService.getMembers(pageNumber);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const getMembersDetails = createAsyncThunk(
    "get-member-details",
    async (member_id, thunkAPI) => {
        try {
            const data = await AuthService.getMemberDetails(member_id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

const initialState = { members: null, member: null };

const memberSlice = createSlice({
    name: "auth",
    initialState,
    extraReducers: {
        [getMembers.fulfilled]: (state, action) => {
            state.members = action.payload.user;
        },
        [getMembers.rejected]: (state, action) => {
            state.members = null;
        },
        [getMembersDetails.fulfilled]: (state, action) => {
            state.member = action.payload.user;
        },
        [getMembersDetails.rejected]: (state, action) => {
            state.member = null;
        }
    },
});

const { reducer } = memberSlice;
export default reducer;
